import { gql } from "@apollo/client";

// Every document that touches a declaration's validity selects it through this
// fragment. `ContaminationDeclarationValidity` has no `id`, so Apollo *replaces*
// the object on every write instead of merging it — two documents selecting
// different subsets of the same entity would take fields away from each other
// (see the head comment of src/utils/graphqlCacheSafety.test.ts, case A).
export const ContaminationDeclarationValidityFields = gql`
    fragment ContaminationDeclarationValidityFields on ContaminationDeclarationValidity {
        isValid
        isPrintable
        activeQuestionIndexList
        missingQuestionIndexList
        inactiveQuestionIndexList
    }
`;
